/* eslint-disable no-shadow */
import { oltEncrypt } from '@/lib/oltEncrypt';
export const state = {
  // 重新 Reload 瀏覽器時 會從 sessionStorage 放進 state.
  user: oltEncrypt.storeDecodeObject(sessionStorage.getItem('admin_user')),
  signup: oltEncrypt.storeDecodeText(sessionStorage.getItem('admin_signup'))
};

export const actions = {};

/*
Mutations其實就是包含著一堆函數的物件，每一個mutation就是一個函數，負責接收actions並更改state的資料，其中有幾個注意事項。

mutation必定是同步函數，沒有例外
mutation是vuex中唯一可以改動state的方法
也就是說在vuex中，如果你要改變state狀態，你一定要經過以下的流程

發出一個action(dispatch an action)
接收到action後，執行對應的mutation (commit a mutation)
透過mutation更改state
*/
export const mutations = {
  loginSuccess(state, user) {
    //console.log('commit loginSuccess : ');
    //console.log(user);
    sessionStorage.setItem('admin_user', oltEncrypt.storeEncodeObject(user));
    state.user = user;
  },
  logout(state) {
    sessionStorage.removeItem('admin_user');
    state.user = null;
  },
  signupToRegister(state, phone) {
    sessionStorage.setItem('admin_signup', oltEncrypt.storeEncodeText(phone));
    state.signup = phone;
  },
  cleanRegister(state, phone) {
    sessionStorage.removeItem('admin_signup');
    state.signup = null;
  }
  /*
  setUser(state, payload) {
    sessionStorage.setItem('user', oltEncrypt.storeEncodeObject(payload));
    state.user = payload;
  },
  */
};

// 取得目前的登入狀態
export const getters = {
  //isAuthenticated: state => Boolean(state.user) || Boolean(sessionStorage.getItem('user')),
  isLogin(state) {
    if (state.user) {
      return true;
    }
    return false;
  },
  isSignup() {
    if (state.signup) {
      return true;
    }
    return false;
  }
};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: false
};
